import { type BqJobResponseApi, bqJobStatus } from '@openx/types/bqJob';

export const defaultFetchError = 'An error occurred while fetching data.';
export const timeoutError = 'The request timeout limit has been exceeded.';

export type HandleBqJobResponse<T> = {
  data: BqJobResponseApi<T>;
  reqCount: number;
  updateReqCount: () => void;
  stopPolling: () => void;
  MAX_REQUEST_COUNT?: number;
  stateUpdateCallback: (param: { errorMessage?: string; data?: T; job_id?: string }) => void;
  continuePollingOnTimeout?: boolean;
};

export const handleBqJobResponse = <T>({
  data,
  reqCount,
  updateReqCount,
  stopPolling,
  MAX_REQUEST_COUNT,
  stateUpdateCallback,
  continuePollingOnTimeout = false,
}: HandleBqJobResponse<T>) => {
  updateReqCount();
  const { status, output, msg, job_id } = data || {};

  switch (status) {
    case bqJobStatus.InProgress:
    case bqJobStatus.Running:
      if (MAX_REQUEST_COUNT && reqCount >= MAX_REQUEST_COUNT) {
        stateUpdateCallback({ errorMessage: timeoutError });

        if (!continuePollingOnTimeout) {
          stopPolling();
        }
      }
      break;
    case bqJobStatus.Ready:
      stateUpdateCallback({ data: output, job_id });
      stopPolling();
      break;
    case bqJobStatus.Error:
      stateUpdateCallback({ errorMessage: msg ?? defaultFetchError });
      stopPolling();
      break;
    default:
      stateUpdateCallback({ errorMessage: `Request status(${status}) unknown.` });
      stopPolling();
      break;
  }
};
